import React, { useEffect } from 'react';

import { Iframe } from '@gogame/components';
import { useMountedState } from '@gogame/hooks-ts';
import { Screen, withScreen } from '@gogame/screens';

import { useQlikSense } from './hooks';

export const QlikSense = withScreen({
  name: 'qlik-sense',
  padding: 0,
})(({ id }) => {
  const [iframeSrc, setIframeSrc] = useMountedState(null);
  const loadIframe = useQlikSense();

  useEffect(() => {
    loadIframe({ id: id }).then(({ link, title }) => {
      window.title = title;
      setIframeSrc(link);
    });
  }, []);

  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Iframe
        src={iframeSrc}
        style={{ marginTop: '-1px', borderTop: '1px solid rgba(0, 0, 0, .12)' }}
      />
    </React.Fragment>
  );
});
